import { render, staticRenderFns } from "./RoomInfomation.vue?vue&type=template&id=51f635f3&scoped=true"
import script from "./RoomInfomation.vue?vue&type=script&lang=js"
export * from "./RoomInfomation.vue?vue&type=script&lang=js"
import style0 from "./RoomInfomation.vue?vue&type=style&index=0&id=51f635f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f635f3",
  null
  
)

export default component.exports